export default {
  bids: []
}
